import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import Topbar from "../../components/Super Admin/TopBar/TopbarCenterManagement";
import EditLogTable from "../../components/Super Admin/Center Management/EditLogTable";
import "../../css/AddStationsPage.css";

const EditLogPage: React.FC = () => {
  return (
    <>
        <Topbar />
        <EditLogTable />
    </>
  );
};

export default EditLogPage;
